/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * Catch Member API
 * API for Catch Member Backend
 * OpenAPI spec version: 1.0.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  WebflowFaqCategoriesResponseDto,
  WebflowFaqsResponseDto
} from '.././model';

import { customFetcher } from '../../../client/customFetcher';




/**
 * @summary Get all FAQ categories from Webflow
 */
export const webflowControllerGetFaqCategories = (
    
 signal?: AbortSignal
) => {
      
      
      return customFetcher<WebflowFaqCategoriesResponseDto>(
      {url: `/webflow/faq-categories`, method: 'GET', signal
    },
      );
    }
  

export const getWebflowControllerGetFaqCategoriesQueryKey = () => {
    return [`/webflow/faq-categories`] as const;
    }

    
export const getWebflowControllerGetFaqCategoriesQueryOptions = <TData = Awaited<ReturnType<typeof webflowControllerGetFaqCategories>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof webflowControllerGetFaqCategories>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWebflowControllerGetFaqCategoriesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof webflowControllerGetFaqCategories>>> = ({ signal }) => webflowControllerGetFaqCategories(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof webflowControllerGetFaqCategories>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type WebflowControllerGetFaqCategoriesQueryResult = NonNullable<Awaited<ReturnType<typeof webflowControllerGetFaqCategories>>>
export type WebflowControllerGetFaqCategoriesQueryError = unknown


export function useWebflowControllerGetFaqCategories<TData = Awaited<ReturnType<typeof webflowControllerGetFaqCategories>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof webflowControllerGetFaqCategories>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof webflowControllerGetFaqCategories>>,
          TError,
          Awaited<ReturnType<typeof webflowControllerGetFaqCategories>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useWebflowControllerGetFaqCategories<TData = Awaited<ReturnType<typeof webflowControllerGetFaqCategories>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof webflowControllerGetFaqCategories>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof webflowControllerGetFaqCategories>>,
          TError,
          Awaited<ReturnType<typeof webflowControllerGetFaqCategories>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useWebflowControllerGetFaqCategories<TData = Awaited<ReturnType<typeof webflowControllerGetFaqCategories>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof webflowControllerGetFaqCategories>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get all FAQ categories from Webflow
 */

export function useWebflowControllerGetFaqCategories<TData = Awaited<ReturnType<typeof webflowControllerGetFaqCategories>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof webflowControllerGetFaqCategories>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getWebflowControllerGetFaqCategoriesQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Get all FAQs from Webflow
 */
export const webflowControllerGetFaqs = (
    
 signal?: AbortSignal
) => {
      
      
      return customFetcher<WebflowFaqsResponseDto>(
      {url: `/webflow/faqs`, method: 'GET', signal
    },
      );
    }
  

export const getWebflowControllerGetFaqsQueryKey = () => {
    return [`/webflow/faqs`] as const;
    }

    
export const getWebflowControllerGetFaqsQueryOptions = <TData = Awaited<ReturnType<typeof webflowControllerGetFaqs>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof webflowControllerGetFaqs>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWebflowControllerGetFaqsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof webflowControllerGetFaqs>>> = ({ signal }) => webflowControllerGetFaqs(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof webflowControllerGetFaqs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type WebflowControllerGetFaqsQueryResult = NonNullable<Awaited<ReturnType<typeof webflowControllerGetFaqs>>>
export type WebflowControllerGetFaqsQueryError = unknown


export function useWebflowControllerGetFaqs<TData = Awaited<ReturnType<typeof webflowControllerGetFaqs>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof webflowControllerGetFaqs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof webflowControllerGetFaqs>>,
          TError,
          Awaited<ReturnType<typeof webflowControllerGetFaqs>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useWebflowControllerGetFaqs<TData = Awaited<ReturnType<typeof webflowControllerGetFaqs>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof webflowControllerGetFaqs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof webflowControllerGetFaqs>>,
          TError,
          Awaited<ReturnType<typeof webflowControllerGetFaqs>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useWebflowControllerGetFaqs<TData = Awaited<ReturnType<typeof webflowControllerGetFaqs>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof webflowControllerGetFaqs>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get all FAQs from Webflow
 */

export function useWebflowControllerGetFaqs<TData = Awaited<ReturnType<typeof webflowControllerGetFaqs>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof webflowControllerGetFaqs>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getWebflowControllerGetFaqsQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



